// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__8AcFD","content":"GlobalSearch_content__Nn6Jf"};